import {
  AssignConfig, getColorDefault, deepAssign,
  formatLogOption,
  getTooltipDefaultOption,
  getYAxisDefaultOption,
  GRID_DEFAULT_OPTION,
  getLegendDefaultOption,
  getXAxisDefaultOption
} from '@/utils/echarts-option/base'
import { applyEchartsFontToOption } from '@/utils/echarts-option/font'

export const X_AXIS_OPTION = {
  type: 'category',
  axisTick: {
    alignWithLabel: false,
  },
  boundaryGap: false,
}

/** series */
export const SERIES_LINE_OPTION = {
  type: 'line',
  showSymbol: false,
}

/** ECharts 折线色（canvas 不支持 CSS var，须为具体色值） */
export const ECHARTS_LINE_COLOR = {
  blue: '#5A9FE8',
  green: '#31C872',
  primary: '#0057B4',
  upload: '#5A9FE8',
  download: '#31C872',
  success: '#1BA041',
  danger: '#C50000',
  warning: '#FB8F10',
  cyan: '#0DC0F8',
} as const

function parseColorRgb (color: string): [number, number, number] | null {
  const c = color.trim()
  if (c.startsWith('#')) {
    const h = c.slice(1)
    if (h.length === 3) {
      return [
        parseInt(h[0] + h[0], 16),
        parseInt(h[1] + h[1], 16),
        parseInt(h[2] + h[2], 16),
      ]
    }
    if (h.length >= 6) {
      return [
        parseInt(h.slice(0, 2), 16),
        parseInt(h.slice(2, 4), 16),
        parseInt(h.slice(4, 6), 16),
      ]
    }
    return null
  }
  const m = c.match(/rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)/)
  if (m) return [Number(m[1]), Number(m[2]), Number(m[3])]
  return null
}

export function toLineRgba (color: string, alpha: number): string {
  const rgb = parseColorRgb(color)
  if (!rgb) return `rgba(0, 87, 180, ${alpha})`
  return `rgba(${rgb[0]}, ${rgb[1]}, ${rgb[2]}, ${alpha})`
}

/** 折线 series 显式着色（避免仅 itemStyle 或 CSS var 导致线条发灰） */
export function withLineSeriesStyle<T extends Record<string, unknown>> (series: T, color: string) {
  return {
    ...series,
    color,
    lineStyle: { color },
    itemStyle: { color },
  }
}

/** 单折线面积渐变 */
export function buildLineAreaStyle (color: string) {
  return {
    color: {
      type: 'linear' as const,
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        { offset: 0, color: toLineRgba(color, 0.2) },
        { offset: 1, color: toLineRgba(color, 0) },
      ],
    },
  }
}

export function getLineOption (config = {} as AssignConfig) {
  return {
    color: getColorDefault(),
    grid: GRID_DEFAULT_OPTION,
    legend: getLegendDefaultOption(),
    xAxis: deepAssign(getXAxisDefaultOption(), X_AXIS_OPTION),
    yAxis: getYAxisDefaultOption(config),
    tooltip: getTooltipDefaultOption(config),
    series: SERIES_LINE_OPTION,
  }
}

export function getAssignLineOption (option: object, config: AssignConfig = {}) {
  option = formatLogOption(option, config)
  return applyEchartsFontToOption(
    deepAssign(getLineOption(config), option) as Record<string, unknown>,
  )
}
